import { createContext } from "react";

export const FullPageDialogContext = createContext<
  | {
      page?: number;
      setPage: (page: number) => void;
      onDismiss?: () => void;
      active: boolean;
      fullHeight: boolean;
      scrollToTop?: () => void;
    }
  | undefined
>(undefined);
